import PropTypes from 'prop-types';
import React from 'react';

class Wysihtml5 extends React.Component {
  componentDidMount() {
    // window.Editor provided by reverb-ui/src/components/legacy/editor.js
    this.editor = window.Editor.init(this.editorId, this.toolbarId);
    this.editor.on('change', () => this.handleChange());
  }

  componentWillUnmount() {
    // Some callbacks are still not cleaned up by this, which may cause errors when
    // submitting the form after closing one of these components.
    // See: https://github.com/Voog/wysihtml/pull/351
    this.editor.destroy();
  }

  get toolbarId() {
    return `${this.props.id}--toolbar`;
  }

  get editorId() {
    return `${this.props.id}--editor`;
  }

  handleChange() {
    this.props.onChange(this.editor.getValue());
  }

  render() {
    return (
      <div>
        <ul id={this.toolbarId} className="wysihtml5-toolbar">
          <li className="d-inline-block">
            <div className="btn-group">
              <a
                tabIndex="-1"
                className="btn btn-small"
                data-wysihtml5-command="bold"
                title="CTRL+B"
                href="#"
                unselectable="on"
              >{I18n.t('js.editorToolbar.bold.label')}
              </a>
              <a
                tabIndex="-1"
                className="btn btn-small"
                data-wysihtml5-command="italic"
                title="CTRL+I"
                href="#"
                unselectable="on"
              >{I18n.t('js.editorToolbar.italic.label')}
              </a>
              <a
                tabIndex="-1"
                className="btn btn-small"
                data-wysihtml5-command="underline"
                title="CTRL+U"
                href="#"
                unselectable="on"
              >{I18n.t('js.editorToolbar.underline.label')}
              </a>
            </div>
          </li>
          <li className="d-inline-block ml-half">
            <div className="btn-group">
              <a
                tabIndex="-1"
                className="btn btn-small icon-l-list"
                data-wysihtml5-command="insertUnorderedList"
                title={I18n.t('js.editorToolbar.list.title')}
                href="#"
                unselectable="on"
              >{I18n.t('js.editorToolbar.list.label')}
              </a>
            </div>
          </li>
        </ul>
        <textarea
          className="wide code required"
          id={this.editorId}
          rows="6"
          name={this.props.name}
          defaultValue={this.props.value}
        />
      </div>
    );
  }
}

Wysihtml5.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default Wysihtml5;
